import { Text } from '@dixa/lib-shared-habla';
import {
  FilterInfo,
  LanguageEvaluationResult,
  SurveyInfo,
} from 'lib-shared-types-api';

import { FilterItemWithDetails } from '../shared';

import { FailedFilterStatus } from './failedFilterStatus';
import { MatchedButNotSelectedStatus } from './matchedButNotSelectedStatus';

type MatchedButNotSelectedFilterItemProps = {
  filter: FilterInfo;
  survey: SurveyInfo | null;
  contactPointLabel: string;
  contactPointValue: string | null;
  statusText: string;
  languageEvaluations: readonly LanguageEvaluationResult[];
  isSuccess: boolean;
  isEligibleRecursive: boolean;
};

/**
 * Displays a filter evaluation that matched but was not selected (lost to
 * priority), or failed for other reasons (incomplete path, missing contact,
 * etc).
 */
export const MatchedButNotSelectedFilterItem = ({
  filter,
  survey,
  contactPointLabel,
  contactPointValue,
  statusText,
  languageEvaluations,
  isSuccess,
  isEligibleRecursive,
}: MatchedButNotSelectedFilterItemProps): JSX.Element => {
  // Only show expandable details for fully eligible filters (complete path)
  // that also have success status and language evaluations
  const hasExpandableDetails =
    isSuccess && isEligibleRecursive && languageEvaluations.length > 0;

  // If has expandable details, use the wrapper
  if (hasExpandableDetails && survey) {
    return (
      <FilterItemWithDetails
        contactPointValue={contactPointValue}
        languageEvaluations={languageEvaluations}
      >
        <MatchedButNotSelectedStatus
          filter={filter}
          survey={survey}
          contactPointLabel={contactPointLabel}
        />
      </FilterItemWithDetails>
    );
  }

  // Simple text without expandable details
  return (
    <Text.Paragraph variant="3" subdued>
      {isEligibleRecursive && survey ? (
        <MatchedButNotSelectedStatus
          filter={filter}
          survey={survey}
          contactPointLabel={contactPointLabel}
        />
      ) : (
        <FailedFilterStatus filter={filter} statusText={statusText} />
      )}
    </Text.Paragraph>
  );
};
